import { render, staticRenderFns } from "./_base-breadcrumbs.vue?vue&type=template&id=7a0e543a&scoped=true&"
import script from "./_base-breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./_base-breadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./_base-breadcrumbs.vue?vue&type=style&index=0&id=7a0e543a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0e543a",
  null
  
)

export default component.exports